import { ITooltipParams } from "ag-grid-community";

const FrequencyCellRenderer = (params: ITooltipParams) => {
    return `${
        params.data.frequency_value
            ? `Every ${params.data.frequency_value} ${params.data.frequency_units}`
            : ""
    }`;
};

export default FrequencyCellRenderer;
